import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  toggle(event) {
    const button = event.currentTarget
    const expanded = button.getAttribute("aria-expanded") === "true"
    const panel = document.getElementById(button.getAttribute("aria-controls"))

    button.setAttribute("aria-expanded", String(!expanded))
    panel.hidden = expanded
  }
}
